import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GTemplateDirective } from "./template.directive";

@NgModule({
  declarations: [GTemplateDirective],
  imports: [CommonModule],
  exports: [GTemplateDirective],
})
export class GTemplateModule {}
